export const customStyles = (state = "default") => {


  if (state === "default") {
    return {
      container: (provided) => ({
        ...provided,
        height: "100%"
      }),
      control: (provided) => ({
        ...provided,
        backgroundColor: "#121212",
        borderColor: "#d7ee8f",
        "&:hover": { borderColor: "#d7ee8f" },
        outline: "none",
        boxShadow: "none",
        borderRadius: "4px",
        height: "100%",
        minHeight: "unset",
        color: "#d7ee8f",
        fontFamily: "inherit",
        fontSize: "2rem",
      }),
      singleValue: (provided) => ({
        ...provided,
        color: "#d7ee8f",
        fontFamily: "inherit",
        fontSize: "2rem",
      }),
      input: (provided) => ({
        ...provided,
        color: "#d7ee8f",
        fontFamily: "inherit",
        fontSize: "2rem",
      }),
      placeholder: (provided) => ({
        ...provided,
        color: "#a4b17a",
        fontFamily: "inherit",
        fontSize: "2rem",
      }),
      menu: (provided) => ({
        ...provided,
        backgroundColor: "#121212",
        border: "1px solid #d7ee8f",
      }),
      option: (provided, optionState) => ({
        ...provided,
        backgroundColor: optionState.isFocused ? "#1d1d1d" : "#121212",
        color: "#d7ee8f",
      }),
      dropdownIndicator: (provided) => ({ ...provided, padding: "0 8px" }),
    }
  }
  else if (state === "error") {
    return {
      container: (provided) => ({
        ...provided,
        height: "100%"
      }),
      control: (provided) => ({
        ...provided,
        backgroundColor: "#121212",
        borderColor: "#f40000",
        "&:hover": { borderColor: "#f40000" },
        outline: "none",
        boxShadow: "none",
        borderRadius: "4px",
        height: "100%",
        minHeight: "unset",
        color: "#d7ee8f",
        fontFamily: "inherit",
        fontSize: "2rem",
      }),
      singleValue: (provided) => ({
        ...provided,
        color: "#d7ee8f",
        fontFamily: "inherit",
        fontSize: "2rem",
      }),
      input: (provided) => ({
        ...provided,
        color: "#d7ee8f",
        fontFamily: "inherit",
        fontSize: "2rem",
      }),
      placeholder: (provided) => ({
        ...provided,
        color: "#a4b17a",
        fontFamily: "inherit",
        fontSize: "2rem",
      }),
      menu: (provided) => ({
        ...provided,
        backgroundColor: "#121212",
        border: "1px solid #f40000",
      }),
      option: (provided, optionState) => ({
        ...provided,
        backgroundColor: optionState.isFocused ? "#1d1d1d" : "#121212",
        color: "#d7ee8f",
      }),
      dropdownIndicator: (provided) => ({ ...provided, padding: "0 8px" }),
    }
  }
};
